// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'
import VueSignaturePad from 'vue-signature-pad'
import Notification from 'vue-notification'
// import vueWebpImage from 'vue-webp-image'
import VueWebpPlugin from 'vue-webp-plugin'

import './utils/prototypes'
import './utils/filters'
import './assets/scss/index.scss'

Vue.config.productionTip = false;
Vue.use(VueSignaturePad)
Vue.use(Notification)
// Vue.use(vueWebpImage)
Vue.use(VueWebpPlugin)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    vuetify,
    store,
    router,
    components: { App },
    template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js